// 일반 설정
//
// @since 2018-10-05
// @Created By jupil.Go <devp018>

import {i18n} from '~/plugins/i18n'
import {CmApiPrefix as apiPrefix} from '~/utils/restApi'

const initGeneralPagedata = () => {
  return {
    admin_common_cm_cli_port: 0, // (integer): CLI 접속 포트 ,
    admin_common_cm_desc: '', // (string, optional): 관리자 일반 통합 설정 설명 ,
    admin_common_cm_device: [], // (Array[Inline Model 2], optional): 관리자 일반 통합 설정 장비 ,
    // admin_common_cm_gui_port: 0, // (integer): GUI 접속 포트 ,
    admin_common_cm_id: 0, // (integer, optional): 관리자 일반 통합 설정 아이디 ,
    admin_common_cm_idle_chk_yn: 0, // (integer): 유휴 상태 체크 여부, 0 사용안함, 1 사용 ,
    admin_common_cm_idle_exit_yn: 0, // (integer): 유휴 상태시 GUI 종료 여부, 0 사용안함, 1 사용 ,
    admin_common_cm_idle_term: 0, // (integer): 최대 유휴 시간(분) ,
    admin_common_cm_login_fail_cnt: 0, //  (integer): 로그인 실패 횟수 ,
    admin_common_cm_sync_yn: 0, // (integer, optional): 객체 관리 통합 설정의 동기화 여부 ,
    admin_common_cm_uname: '', // (string): 관리자 일반 통합 설정 이름 ,
    admin_login_uname: '', // (string, optional): 관리자 로그인 이름 ,
    admin_name: '', // (string, optional): 관리자 이름 ,
    cfg_admin_id: 0, // (integer, optional): 설정 관리자 아이디 ,
    cfg_dt: '', // (string, optional): 설정 일시 ,
    device_list_name: '', // (string, optional): 장비리스트 이름
    device_id: [] // (Array[integer]): 대상장비
  }
}

export const state = () => ({
  tmpAdminCommonCmId: void 0,
  fndItemList: {
    admin_common_cm_id_list: ''
  },
  url: `${apiPrefix}/managers-common-cm`,
  selectedItem: {},
  generalDataList: [],
  generalPageData: initGeneralPagedata()
})

export const mutations = {
  tableHeaderMutation: (state, data) => { // 테이블 헤더에서 체크박스 선택
    state.generalDataList = _.map(state.generalDataList, (item) => {
      item.admin_common_cm_sync_yn = data
      return item
    })
  },
  // 리스트 조회
  getGeneralList (state, item) {
    state.generalDataList = item.map(o => {
      const listLength = _.size(o.admin_common_cm_device)
      let
        list = [],
        listName = ''
      if (listLength > 0) {
        list = o.admin_common_cm_device.map(id => id.device_id)
        listName = (listLength > 1) ? i18n.t('cmn.deviceTypeText', {name: o.admin_common_cm_device[0].device_uname, cnt: listLength - 1}) : o.admin_common_cm_device[0].device_uname
      }
      return _.assign(o, { 'device_id': list, 'device_list_name': listName })
    })
  },
  setAdminCommonCmId (state, id) {
    state.tmpAdminCommonCmId = Number(id)
  },
  clearAdminCommonCmId (state) {
    state.tmpAdminCommonCmId = void 0
  },
  addGeneral: (state, item) => {
    state.generalDataList.push(item)
  },
  // edtGeneral: (state, item) => {
  //   state.generalDataList.splice(state.selectedItem.itemIndex, 1, item)
  // },
  // delGeneral: (state, itemIndexList) => {
  //   itemIndexList = _.sortBy(itemIndexList, 'itemIndex').reverse()
  //   for (const itemIndex of itemIndexList) {
  //     state.generalDataList.splice(itemIndex, 1)
  //   }
  // },
  delGeneral: (state, itemList) => {
    for (const itemKey of itemList.admin_common_cm_id_list) {
      const idx = _.findIndex(state.generalDataList, {admin_common_cm_id: itemKey})
      if (idx >= 0) {
        state.generalDataList.splice(idx, 1)
      }
    }
  },
  setGeneralDialog: (state, data) => {
    state.selectedItem = data
    state.generalPageData.admin_common_cm_id = data.admin_common_cm_id
    state.generalPageData.admin_common_cm_cli_port = data.admin_common_cm_cli_port
    state.generalPageData.admin_common_cm_desc = data.admin_common_cm_desc
    // state.generalPageData.admin_common_cm_gui_port = data.admin_common_cm_gui_port
    state.generalPageData.admin_common_cm_idle_chk_yn = data.admin_common_cm_idle_chk_yn
    state.generalPageData.admin_common_cm_idle_exit_yn = data.admin_common_cm_idle_exit_yn
    state.generalPageData.admin_common_cm_idle_term = data.admin_common_cm_idle_term
    state.generalPageData.admin_common_cm_login_fail_cnt = data.admin_common_cm_login_fail_cnt
    state.generalPageData.admin_common_cm_sync_yn = data.admin_common_cm_sync_yn
    state.generalPageData.admin_common_cm_uname = data.admin_common_cm_uname
    state.generalPageData.device_list_name = data.device_list_name
    state.generalPageData.device_id = data.device_id
  },
  clearGeneralDialog: (state, ccFlag) => {
    delete state.generalPageData.admin_common_cm_id
    state.generalPageData.admin_common_cm_cli_port = 22
    state.generalPageData.admin_common_cm_desc = ''
    // state.generalPageData.admin_common_cm_gui_port = 443
    state.generalPageData.admin_common_cm_idle_chk_yn = 0
    state.generalPageData.admin_common_cm_idle_exit_yn = 0
    state.generalPageData.admin_common_cm_idle_term = ccFlag ? 10 : 30
    state.generalPageData.admin_common_cm_login_fail_cnt = 3
    state.generalPageData.admin_common_cm_sync_yn = 0
    state.generalPageData.admin_common_cm_uname = ''
    state.generalPageData.device_list_name = ''
    state.generalPageData.device_id = []
  }
}

export const actions = {
  // 리스트 조회
  async getGeneralList ({commit, state}, isShowLoading) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      let axiosParam = {}
      if (isShowLoading !== undefined && isShowLoading === false) {
        axiosParam = {loading: false}
      }

      res = await this.$axios.$get(`${state.url}/0`, axiosParam)
      if (res.code === 'ok') {
        commit('getGeneralList', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 미사용
  // async addEmptyGeneral ({commit, state}) {
  //   let res = {
  //     code: 'ok',
  //     result: {}
  //   }
  //
  //   try {
  //     res = await this.$axios.$post(state.url, null, {loading: false, successAlert: false})
  //     if (res.code === 'ok') {
  //       commit('setAdminCommonCmId', res.result.msg)
  //     }
  //   } catch (e) {
  //     res.code = 'nok'
  //     res.result.msg = e.message
  //   }
  //   return res
  // },
  async addGeneral ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const admParam = _.cloneDeep(state.generalPageData)

      res = await this.$axios.$post(`${state.url}`, admParam, {
        loading: false,
        successAlert: false
      })
      if (res.code === 'ok') {
        commit('clearAdminCommonCmId') // Bean Admin Common Cm Id 해제.
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async edtGeneral ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const param = _.cloneDeep(state.generalPageData)

      res = await this.$axios.$post(`${state.url}/${param.admin_common_cm_id}`, param, {alertMsg: i18n.t('msg.updateApply')})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async delGeneral ({commit, state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      res = await this.$axios.$put(state.url, param.idList, {alertMsg: i18n.t('msg.removeApply')})
      if (res.code === 'ok') {
        commit('delGeneral', param.idList)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async processSync ({commit, state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      res = await this.$axios.$post(`${state.url}/multi`, param, {loading: false, isNotAlert: true})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async finalCommand ({commit, state}, type) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const axiosConfig = (type === 'apply') ? { applyMsg: true } : { cancelMsg: true }
      res = await this.$axios.$put(`${state.url}/${type}`, void 0, axiosConfig)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}

export const getters = {}

export const strict = false
